import { useQuery } from "@tanstack/react-query";
import { ListPage } from "@/archetypes/ListPage";
import { DataGrid, type DataGridColumn } from "@/components/data-grid";
import { priceTableTemplatesApi, priceTableKeys, type PriceTableTemplate } from "@/lib/price-tables";

export function PriceTableTemplatesAdminPage() {
  const { data, isLoading } = useQuery({ queryKey: priceTableKeys.templates(), queryFn: () => priceTableTemplatesApi.list() });
  const cols: DataGridColumn<PriceTableTemplate>[] = [
    { id: "id", header: "#", accessor: (r) => r.priceTableTemplateId, width: "64px" },
    { id: "pt", header: "Price table", accessor: (r) => r.priceTableId },
    { id: "desc", header: "Description", accessor: (r) => r.description ?? "—" },
  ];
  return (
    <ListPage backTo="/admin" title="Price-table templates">
      <DataGrid rows={data ?? []} columns={cols} rowKey={(r) => r.priceTableTemplateId}
        totalRows={data?.length ?? 0} pageIndex={0} pageSize={Math.max(data?.length ?? 1, 1)} loading={isLoading}
        onPageChange={() => {}} emptyHeadline="No templates" />
    </ListPage>
  );
}
